"use client";

import { Dropdown } from "rizzui";
import { IoIosSettings } from "react-icons/io";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";

interface PackageActionsProps {
  handleDelete: () => void;
  handleEdit?: () => void;
}

export default function PackageActions({
  handleDelete,
  handleEdit,
}: PackageActionsProps) {
  return (
    <Dropdown>
      <Dropdown.Trigger className="hover:bg-gray-300 p-2 rounded-full">
        <IoIosSettings size={20} className="p-0" />
      </Dropdown.Trigger>
      <Dropdown.Menu className="w-40">
        <Dropdown.Item
          as="button"
          onClick={handleEdit}
          className="border-2 border-gray-400"
        >
          <CiEdit className="mr-2" size={20} />
          Edit
        </Dropdown.Item>
        <Dropdown.Item
          as="button"
          className="text-red-400 border-2 border-red-400 mt-2"
          onClick={handleDelete}
        >
          <MdDeleteOutline className="mr-2" size={20} />
          Delete
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
